var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gotop",class:{'show':_vm.gotop},on:{"click":_vm.goTop}},[_c('svg',{attrs:{"height":"42","width":"42"}},[_c('circle',{attrs:{"cx":"21","cy":"21","r":"20"}})]),_c('i',{staticClass:"fas fa-chevron-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }